import { useEffect, useState } from "react";

export const useMobileBreakpoint = (maxWidth = 600): boolean => {
	const mediaQuery = `(max-width: ${maxWidth}px)`;
	const getMatches = () =>
		typeof window !== "undefined" &&
		typeof window.matchMedia === "function" &&
		window.matchMedia(mediaQuery).matches;

	const [isMobile, setIsMobile] = useState(getMatches);

	useEffect(() => {
		if (
			typeof window === "undefined" ||
			typeof window.matchMedia !== "function"
		) {
			return;
		}

		const mediaQueryList = window.matchMedia(mediaQuery);
		const handleChange = (event: MediaQueryListEvent) => {
			setIsMobile(event.matches);
		};

		setIsMobile(mediaQueryList.matches);

		if (typeof mediaQueryList.addEventListener === "function") {
			mediaQueryList.addEventListener("change", handleChange);
			return () => mediaQueryList.removeEventListener("change", handleChange);
		}

		mediaQueryList.addListener(handleChange);
		return () => mediaQueryList.removeListener(handleChange);
	}, [mediaQuery]);

	return isMobile;
};
